package br.com.texeratx.boardgametimeapp.ui.screens.players.edit

import androidx.compose.animation.AnimatedContent
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material3.Button
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings
import br.com.texeratx.boardgametimeapp.core.image.LocalImagePreview
import br.com.texeratx.boardgametimeapp.ui.utils.DateVisualTransformation
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppScreenScaffold
import br.com.texeratx.boardgametimeapp.ui.components.designsystem.AppTopBarColors

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EditPlayerUI(
    state: EditPlayerState,
    onValueChange: ((EditPlayerState) -> EditPlayerState) -> Unit,
    onPickImage: () -> Unit,
    onClearImage: () -> Unit,
    onSave: () -> Unit,
    onBack: () -> Unit
) {
    val S = LocalStrings.current
    AppScreenScaffold(
        topBar = {
            TopAppBar(
                title = { Text(S.editPlayerTitle, fontWeight = FontWeight.Bold) },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.Default.ArrowBack, contentDescription = S.back)
                    }
                },
                colors = AppTopBarColors()
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .padding(padding)
                .padding(16.dp)
                .fillMaxSize()
                .verticalScroll(rememberScrollState()),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {

            TextField(
                value = state.name,
                onValueChange = { v -> onValueChange { it.copy(name = v) } },
                label = { Text(S.labelName) },
                modifier = Modifier.fillMaxWidth()
            )

            TextField(
                value = state.nickname,
                onValueChange = { v -> onValueChange { it.copy(nickname = v) } },
                label = { Text(S.labelNicknameOptional) },
                modifier = Modifier.fillMaxWidth()
            )

            Text(
                text = S.sectionPhotoAvatar,
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold
            )

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                OutlinedButton(
                    onClick = onPickImage,
                    enabled = !state.isSaving && !state.isUploadingImage
                ) { Text(S.selectImage) }

                OutlinedButton(
                    onClick = onClearImage,
                    enabled = state.selectedImageName != null && !state.isSaving && !state.isUploadingImage
                ) { Text(S.remove) }

                if (state.isUploadingImage) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(22.dp),
                        strokeWidth = 2.dp
                    )
                }
            }

            // ✅ Preview: se escolheu imagem local, mostra ela
            if (state.localImageBytes != null) {
                LocalImagePreview(
                    bytes = state.localImageBytes,
                    contentDescription = S.previewAvatar,
                    modifier = Modifier
                        .size(160.dp)
                        .clip(CircleShape)
                )
            } else {
                // opcional: se não tem local, mas tem URL, você pode manter o avatar atual aqui
                // (se quiser eu te passo com PlayerAvatar + Coil também)
            }

            TextField(
                value = state.birthday,
                onValueChange = { raw ->
                    onValueChange { it.copy(birthday = raw.filter(Char::isDigit).take(8)) }
                },
                label = { Text(S.labelBirthdayOptional) },
                visualTransformation = DateVisualTransformation(),
                modifier = Modifier.fillMaxWidth()
            )

            TextField(
                value = state.phone,
                onValueChange = { v -> onValueChange { it.copy(phone = v) } },
                label = { Text(S.labelPhoneOptional) },
                modifier = Modifier.fillMaxWidth()
            )

            state.error?.let {
                Text(it, color = MaterialTheme.colorScheme.error)
            }

            Spacer(Modifier.height(8.dp))

            Button(
                onClick = onSave,
                modifier = Modifier.fillMaxWidth(),
                enabled = !state.isSaving && !state.isUploadingImage
            ) {
                AnimatedContent(targetState = state.isSaving, label = "save-loading") { saving ->
                    if (saving) {
                        CircularProgressIndicator(
                            modifier = Modifier.size(20.dp),
                            strokeWidth = 2.dp,
                            color = MaterialTheme.colorScheme.onPrimary
                        )
                    } else {
                        Text(S.saveChanges)
                    }
                }
            }
        }
    }
}
